export const PRICING = {
    DEFAULT_AMOUNT: 39,
}